export enum TableColumnHeaderSearchType {
  Date = 'date',
  Text = 'text',
  Dropdown = 'dropdown',
  Number = 'number'
}
